"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsItem = void 0;
var React = __importStar(require("react"));
var useHeaderProps_1 = require("../../../hooks/useHeaderProps");
var useDisplayMode_1 = require("../useDisplayMode");
var DropdownOption_1 = require("../../_shared/DropdownOption");
var HeaderLink_1 = require("../../_shared/HeaderLink");
var NavLink_1 = require("../../_shared/NavLink");
var TeamsItem = function () {
    var _a = (0, useHeaderProps_1.useHeaderProps)(), _js = _a._js, activeItem = _a.activeItem;
    var displayMode = (0, useDisplayMode_1.useDisplayMode)();
    var linkProps = {
        href: '/Teams',
        className: 'header-link__teams',
        'data-feature-id': 'header_link_teams',
    };
    var content = _js('Teams');
    switch (displayMode) {
        case 'more':
            return React.createElement(DropdownOption_1.DropdownOption, __assign({}, linkProps), content);
        case 'hamburger':
            return React.createElement(NavLink_1.NavLink, __assign({}, linkProps), content);
        default:
            return (React.createElement(HeaderLink_1.HeaderLink, __assign({}, linkProps, { underlined: activeItem === 'teams' }), content));
    }
};
exports.TeamsItem = TeamsItem;
